import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'PhoneNumber'
})
export class PhonePipe implements PipeTransform
{

    transform(value: any)
    {
        const replacedValue = ('' + value).replace(/\D/g, '');
        const result = replacedValue.match(/^(\d{3})(\d{3})(\d{4})$/);
        return (!result) ? value : '(' + result[1] + ') ' + result[2] + '-' + result[3];
    }

}
